import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

const UNREAD_KEY = "waba_unread";
const getStoredUnread = () => { try { return JSON.parse(localStorage.getItem(UNREAD_KEY) || "{}"); } catch { return {}; } };
const saveStoredUnread = (map) => { try { localStorage.setItem(UNREAD_KEY, JSON.stringify(map)); } catch {} };

export const markChatRead = createAsyncThunk(
  "wabaChat/markRead",
  async (chatNumber) => {
    await api.post("/api/whatsapp/mark-read", { chatNumber });
    return chatNumber;
  }
);

// Lightweight fetch — only unread conversations, no messages loaded.
// Dispatched on login to populate sidebar badges without loading full chat list.
export const fetchWabaUnreadCounts = createAsyncThunk(
  "wabaChat/fetchUnreadCounts",
  async (_, { dispatch }) => {
    try {
      const response = await api.post("/api/whatsapp/conversations", {
        type: "chats",
        page: 1,
        limit: 100,
        search: "",
      });
      dispatch(loadOldChat({
        data: response.data.data || [],
        totalCount: response.data.totalCount || 0,
      }));
    } catch (e) {
      console.warn("[WabaUnread] fetch failed:", e?.response?.data || e?.message);
    }
  }
);

const initialState = {
  conversations: [],
  activeChatId: null,
  showContact: false,
  totalCount: 0,
  messagePagination: {},
  incomingToasts: [],    // [{ from, senderName, text, type }] — stacked toasts
  pendingOpenChatId: null, // set by WA toast "Open chat" → consumed by chat page
  chatRefreshTrigger: {}, // { [chatId]: number } — incremented to trigger message re-fetch
};

const wabaChatSlice = createSlice({
  name: "wabaChat",
  initialState,
  reducers: {
    loadOldChat(state, action) {

      const { data, totalCount } = action.payload;
      state.totalCount = totalCount;

      // state.conversations = data?.map((chat) => {
      //   // state.conversations = action.payload.map((chat) => {


      //   const messages = chat.messages?.map((msg) => {
      //     const type = msg.messageType || "text";

      //     let text;
      //     let media;
      //     let location;
      //     let contacts;
      //     let template;

      //     if (type === "text") {
      //       text =
      //         typeof msg.content?.text === "string"
      //           ? msg.content.text
      //           : msg.content?.text?.body || "";
      //     }

      //     if (["image", "video", "audio", "document"].includes(type)) {
      //       const mediaUrl = msg.s3dataurl || msg.content?.mediaUrl || "";

      //       media = {
      //         url: mediaUrl,
      //         mimeType: msg.content?.mimeType || msg.content?.mime_type,
      //         attachmentName:
      //           msg.attachmentName || msg.content?.fileName || "Attachment",
      //         attachmentCaption: msg.content?.caption || "",
      //       };
      //     }

      //     if (type === "location") {
      //       location = {
      //         latitude: msg.content?.latitude,
      //         longitude: msg.content?.longitude,
      //         name: msg.content?.name || "",
      //         address: msg.content?.address || "",
      //       };
      //     }

      //     if (type === "contacts") {
      //       contacts = Array.isArray(msg.content?.contacts)
      //         ? msg.content.contacts?.map((c) => ({
      //           name:
      //             c.name?.formatted_name || c.name?.first_name || "Unknown",
      //           phones: c.phones || [],
      //         }))
      //         : [];
      //     }
      //     if (type === "template" && msg.content?.template) {
      //       template = {
      //         name: msg.content.template.name,
      //         language: msg.content.template.language,
      //         components: msg.content.template.components,
      //         resolved: msg.content.template.resolved,
      //       };

      //       text =
      //         template.resolved?.body ||
      //         template.components
      //           ?.filter((c) => c.type === "BODY")
      //           ?.map((c) => c.text)
      //           .join("\n");
      //     }

      //     return {
      //       id: msg._id,
      //       from: msg.direction === "incoming" ? "user" : "agent",
      //       type,
      //       text,
      //       media,
      //       location,
      //       contacts,
      //       template,
      //       name: msg.senderName,
      //       status:
      //         msg.direction === "outgoing" ? msg.status || "sent" : undefined,
      //       metaMessageId: msg.metaMessageId || undefined,
      //       date: new Date(msg.messageTimestamp).toLocaleDateString("en-GB", {
      //         day: "2-digit",
      //         month: "short",
      //         year: "numeric",
      //       }),

      //       time: new Date(msg.messageTimestamp).toLocaleTimeString([], {
      //         hour: "2-digit",
      //         minute: "2-digit",
      //       }),
      //     };
      //   });



      //   const lastMsg = messages[messages.length - 1];

      //   const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

      //   const lastIncomingTime = chat.lastIncomingTime;

      //   const isHistory =
      //     lastIncomingTime ?
      //       Date.now() - new Date(lastIncomingTime).getTime() > TWENTY_FOUR_HOURS : true;

      //   const lastMessage =
      //     lastMsg?.type === "text"
      //       ? lastMsg.text
      //       : lastMsg?.type === "image"
      //         ? "📷 Photo"
      //         : lastMsg?.type === "video"
      //           ? "🎥 Video"
      //           : lastMsg?.type === "audio"
      //             ? "🎤 Voice message"
      //             : lastMsg?.type === "document"
      //               ? "📎 Document"
      //               : lastMsg?.type === "location"
      //                 ? "📍 Location"
      //                 : lastMsg?.type === "contacts"
      //                   ? "👤 Contact"
      //                   : lastMsg?.type === "template"
      //                     ? "📄 Template"
      //                     : "New message";

      //   let unread = 0;

      //   if (messages.length) {
      //     for (let i = messages.length - 1; i >= 0; i--) {
      //       if (messages[i].from === "user") unread++;
      //       else break;
      //     }
      //   }

      //   return {
      //     id: chat.from,
      //     isHistory,
      //     from: chat.from,
      //     name: chat.senderName,
      //     phone: `+${chat.from}`,
      //     image: ``,
      //     messages,
      //     lastMessage,
      //     unread,
      //     isWabaChat: chat.isWabaChat || false,
      //     chatName: chat.chatName,


      //     firstUserMessage: chat.firstUserMessage,
      //     lastActiveConversation: chat.lastActiveConversation,
      //     lastIncomingTime: chat.lastIncomingTime,
      //     lastMessageTime: chat.lastMessageTime,
      //     originalName: chat.originalName,
      //     sessionMessages: chat.sessionMessages,
      //     templateMessages: chat.templateMessages,
      //     userActiveStatus: chat.userActiveStatus,
      //   };
      // });

      const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

      const incoming = (data ?? []).map((chat) => {
        const lastIncomingTime = chat.lastIncomingTime;
        const isHistory = lastIncomingTime
          ? Date.now() - new Date(lastIncomingTime).getTime() > TWENTY_FOUR_HOURS
          : true;

        const lastMessage =
          chat.lastMessageType === "text"
            ? chat.lastMessage
            : chat.lastMessageType === "image"
              ? "📷 Photo"
              : chat.lastMessageType === "video"
                ? "🎥 Video"
                : chat.lastMessageType === "audio"
                  ? "🎤 Voice message"
                  : chat.lastMessageType === "document"
                    ? "📎 Document"
                    : chat.lastMessageType === "location"
                      ? "📍 Location"
                      : chat.lastMessageType === "contacts"
                        ? "👤 Contact"
                        : chat.lastMessageType === "template"
                          ? "📄 Template"
                          : "New message";

        // Keep messages already loaded for this conversation (e.g. opened before)
        const existing = state.conversations.find((c) => c.from === chat.from);

        return {
          id: chat.from,
          isHistory,
          from: chat.from,
          name: chat.chatName || chat.originalName,
          phone: `+${chat.from}`,
          image: "",
          messages: existing?.messages ?? [],
          lastMessage: lastMessage || "No messages yet",
          unread: existing?.unread ?? Math.max(chat.unreadCount ?? 0, getStoredUnread()[chat.from] ?? 0),
          isWabaChat: chat.isWabaChat || false,
          chatName: chat.chatName,
          chatCompany: chat.chatCompany || null,
          firstUserMessage: chat.firstUserMessage,
          lastActiveConversation: chat.lastActiveConversation,
          lastIncomingTime: chat.lastIncomingTime,
          lastMessageTime: chat.lastMessageTime,
          originalName: chat.originalName,
          sessionMessages: chat.sessionMessages,
          templateMessages: chat.templateMessages,
          userActiveStatus: chat.userActiveStatus,
        };
      });

      // IDs returned by this API call
      const apiIds = new Set(incoming.map((c) => c.from));

      // Preserve ALL conversations that were already in the store but not
      // returned by this API call.  This prevents a second fetch (triggered by
      // a dependency change like isWhatsappConnected loading) from wiping out
      // conversations that a previous fetch already loaded correctly.
      // The isHistory flag + filteredConversations filter in the UI handles
      // showing the right subset per tab — no need to remove the others here.
      const preserved = state.conversations.filter((c) => !apiIds.has(c.from));

      state.conversations = [...incoming, ...preserved];
    },
    setChatMessages(state, action) {
      const { chatId, messages, pagination } = action.payload;

      const chat = state.conversations.find(c => c.id === chatId);
      if (!chat) return;

      chat.messages = messages;

      state.messagePagination[chatId] = pagination;
    },
    appendOldMessages(state, action) {
      const { chatId, messages, pagination } = action.payload;

      const chat = state.conversations.find(c => c.id === chatId);
      if (!chat) return;

      // ✅ prepend old messages
      chat.messages = [...messages, ...chat.messages];

      state.messagePagination[chatId] = pagination;
    },
    setActiveChat(state, action) {
      state.activeChatId = action.payload;
      state.showContact = false;
      const chat = state.conversations.find((c) => c.id === action.payload);
      if (chat) {
        chat.unread = 0;
        const stored = getStoredUnread();
        delete stored[action.payload];
        saveStoredUnread(stored);
      }
      // Dismiss toast if user opens that chat
      if (Array.isArray(state.incomingToasts))
        state.incomingToasts = state.incomingToasts.filter((t) => t.from !== action.payload);
    },
    clearWabaToast(state, action) {
      if (!Array.isArray(state.incomingToasts)) { state.incomingToasts = []; return; }
      if (action.payload) {
        state.incomingToasts = state.incomingToasts.filter((t) => t.from !== action.payload);
      } else {
        state.incomingToasts = [];
      }
    },
    setPendingOpenChat(state, action) {
      state.pendingOpenChatId = action.payload;
    },
    clearPendingOpenChat(state) {
      state.pendingOpenChatId = null;
    },

    toggleContact(state, action) {
      state.showContact = action.payload;
    },
    deleteChat(state, action) {
      const conversationId = action.payload;

      state.conversations = state.conversations.filter(
        (c) => c.id !== conversationId
      );

      if (state.activeChatId === conversationId) {
        state.activeChatId = null;
      }
    },
    sendMessage(state, action) {
      const {
        chatId,
        text,
        audio,
        file,
        type,
        name,
        caption,
        template,
        tempId,
      } = action.payload;

      const chatIndex = state.conversations.findIndex((c) => c.id === chatId);

      if (chatIndex === -1) return;

      const chat = state.conversations[chatIndex];

      chat.messages.push({
        id: `msg_${Date.now()}`,
        tempId,
        metaMessageId: null,
        status: "sent",
        from: "agent",
        type,
        name: name || chat.name,
        text: type === "text" ? text : undefined,
        template: type === "template" ? template : undefined,

        media:
          type !== "text" && type !== "template"
            ? {
              url: URL.createObjectURL(file || audio),
              mimeType: file?.type || audio?.type,
              fileName: file?.name,
              attachmentCaption: caption,
            }
            : undefined,
        date: new Date().toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      });

      chat.lastMessage =
        type === "text"
          ? text
          : type === "image"
            ? "📷 Photo"
            : type === "video"
              ? "🎥 Video"
              : type === "audio"
                ? "🎤 Voice message"
                : type === "template"
                  ? "📄 Template"
                  : "📎 Document";

      chat.unread = 0;
      chat.lastMessageTime = new Date().toISOString();
      if (chatIndex > 0) {
        state.conversations.splice(chatIndex, 1);
        state.conversations.unshift(chat);
      }
    },

    receiveMessage(state, action) {
      console.log("[reducer] receiveMessage start — from:", action.payload?.from, "id:", action.payload?.id, "type:", action.payload?.type);
      const {
        from,
        id,
        timestamp,
        text,
        type,
        senderName,
        s3dataurl,
        document,
        file,
        audio,
        image,
        video,
        location,
        contacts,
        attachmentName,
      } = action.payload;

      if (!from || !id) { console.log("[reducer] EARLY EXIT — missing from or id"); return; }
      console.log("[reducer] from/id OK — chatIndex:", state.conversations.findIndex(c => c.from === from));

      // const messageTime = new Date(Number(timestamp) * 1000);
      const messageTime = new Date(Number(timestamp) * 1000);

      let chatIndex = state.conversations.findIndex((c) => c.from === from);
      let chat;

      if (chatIndex === -1) {
        chat = {
          id: from,
          from,
          name: senderName,
          phone: `+${from}`,
          image: "",
          messages: [],
          lastMessage: "",
          unread: getStoredUnread()[from] ?? 0,
          isHistory: false,
        };
        state.conversations.unshift(chat);
        chatIndex = 0;
      } else {
        chat = state.conversations[chatIndex];
      }

      if (chat.messages.some((msg) => msg.id === id)) { console.log("[reducer] EARLY EXIT — duplicate msg id:", id); return; }
      console.log("[reducer] not duplicate — proceeding to add message");

      const normalizedText = typeof text === "string" ? text : text?.body || "";

      const mediaSource = document || file || image || video || audio || null;
      const caption = mediaSource?.caption || "";

      const messageDirection = action.payload?.direction === "outgoing" ? "agent" : "user";

      chat.messages.push({
        id,
        from: messageDirection,
        name: senderName,
        type,

        text: type === "text" ? normalizedText : undefined,

        media:
          type !== "text" &&
            type !== "location" &&
            type !== "contacts" &&
            mediaSource
            ? {
              url: s3dataurl,
              mimeType:
                mediaSource.mime_type ||
                mediaSource.mimeType ||
                "application/octet-stream",

              attachmentName:
                attachmentName ||
                mediaSource.filename ||
                mediaSource.name ||
                "Attachment",

              attachmentCaption: caption,
            }
            : undefined,

        location:
          type === "location" && location
            ? {
              latitude: location.latitude,
              longitude: location.longitude,
              name: location.name || "Location",
              address: location.address || "",
            }
            : undefined,

        contacts:
          type === "contacts" && Array.isArray(contacts)
            ? contacts?.map((c) => ({
              name: c.name?.formatted_name || c.name?.first_name || "Unknown",
              phones: c.phones || [],
            }))
            : undefined,

        // time: messageTime.toLocaleTimeString([], {
        //   hour: "2-digit",
        //   minute: "2-digit",
        // }),
        date: messageTime.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }),
  time: messageTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  }),
      });

      chat.lastMessage =
        type === "text"
          ? normalizedText
          : type === "image"
            ? "📷 Photo"
            : type === "video"
              ? "🎥 Video"
              : type === "audio"
                ? "🎤 Voice message"
                : type === "document"
                  ? "📎 Document"
                  : type === "location"
                    ? "📍 Location"
                    : type === "contacts"
                      ? "👤 Contact"
                      : "New message";

      if (messageDirection === "user") {
        console.log("[reducer] message added to chat — unread before:", chat.unread);
        chat.unread += 1;
        console.log("[reducer] unread after:", chat.unread);
        const stored = getStoredUnread();
        stored[chat.id] = chat.unread;
        saveStoredUnread(stored);
      }
      chat.lastMessageTime = messageTime.toISOString();
      if (chatIndex > 0) {
        state.conversations.splice(chatIndex, 1);
        state.conversations.unshift(chat);
      }

      // Show incoming message toast only when not actively viewing this chat
      console.log("[reducer] activeChatId:", state.activeChatId, "from:", from, "will show toast:", from !== state.activeChatId);
      if (messageDirection === "user" && from !== state.activeChatId) {
        if (!Array.isArray(state.incomingToasts)) state.incomingToasts = [];
        const normalizedText = typeof text === "string" ? text : text?.body || "";
        const previewText = type === "text" ? normalizedText
          : type === "image" ? "📷 Photo"
          : type === "video" ? "🎥 Video"
          : type === "audio" ? "🎤 Voice message"
          : type === "document" ? "📎 Document"
          : "New message";
        const existing = state.incomingToasts.findIndex((t) => t.from === from);
        if (existing !== -1) {
          state.incomingToasts[existing].messages.push(previewText);
        } else {
          state.incomingToasts.push({ from, senderName, messages: [previewText], type });
        }
      }

    },

    startNewChat(state, action) {
      const { name, phone, image, isWabaChat } = action.payload;

      const from = (phone || "").replace(/\D/g, "");

      let chatIndex = state.conversations.findIndex((c) => c.from === from);
      let chat;

      if (state.activeChatId) {
        const activeIndex = state.conversations.findIndex(
          (c) => c.id === state.activeChatId,
        );

        if (
          activeIndex !== -1 &&
          state.conversations[activeIndex].messages.length === 0
        ) {
          state.conversations.splice(activeIndex, 1);
        }
      }

      chatIndex = state.conversations.findIndex((c) => c.from === from);

      if (chatIndex === -1) {
        chat = {
          id: from,
          from,
          name: name || from,
          phone: `+${from}`,
          image: image || "",
          messages: [],
          lastMessage: "",
          unread: 0,
          isWabaChat: !!isWabaChat,
        };

        state.conversations.unshift(chat);
      } else {
        chat = state.conversations[chatIndex];
        chat.isWabaChat = !!isWabaChat;
      }

      state.activeChatId = chat.id;
    },
    clearEmptyDraftChats(state) {
      state.conversations = state.conversations.filter(
        (chat) => chat.messages.length > 0,
      );

      if (
        state.activeChatId &&
        !state.conversations.some((c) => c.id === state.activeChatId)
      ) {
        state.activeChatId = null;
      }
    },
    updateMessageStatus(state, action) {
      const { conversationId, metaMessageId, status } = action.payload;
      console.log(conversationId, metaMessageId, status, "bvhjgffchjkkhgh");

      const chat = state.conversations.find((c) => c.id === conversationId);
      if (!chat) return;

      const msg = chat.messages.find((m) => m.metaMessageId === metaMessageId);
      if (!msg) return;

      if (msg.from !== "agent") return;

      msg.status = status;
    },
    requestChatRefresh(state, action) {
      const { chatId } = action.payload;
      state.chatRefreshTrigger[chatId] = (state.chatRefreshTrigger[chatId] || 0) + 1;
    },

    attachMetaMessageId(state, action) {
      const { chatId, tempId, metaMessageId } = action.payload;
      console.log(
        chatId,
        tempId,
        metaMessageId,
        "chatId, tempId, metaMessageId",
      );

      const chat = state.conversations.find((c) => c.id === chatId);
      console.log(chat, "hjgfcfhvj");

      if (!chat) return;

      const msg = chat.messages.find((m) => m.tempId === tempId);
      console.log(msg, "jghfdxfchvjbkn");

      if (!msg) return;
      console.log(metaMessageId, "hjgfchvjbkn");

      msg.metaMessageId = metaMessageId;
      console.log(msg.metaMessageId, "hjgfdfxgchvjk");

    },
  },
});

export const {
  loadOldChat,
  setActiveChat,
  toggleContact,
  sendMessage,
  receiveMessage,
  clearEmptyDraftChats,
  startNewChat,
  updateMessageStatus,
  attachMetaMessageId,
  deleteChat,
  setChatMessages,
  appendOldMessages,
  clearWabaToast,
  setPendingOpenChat,
  clearPendingOpenChat,
  requestChatRefresh,
} = wabaChatSlice.actions;

export const selectWabaTotalUnread = (state) =>
  state.wabaChat.conversations.reduce((sum, c) => sum + (c.unread || 0), 0);

export const selectWabaChatUnread = (state) =>
  state.wabaChat.conversations
    .filter((c) => !c.isHistory)
    .reduce((sum, c) => sum + (c.unread || 0), 0);

export const selectWabaHistoryUnread = (state) =>
  state.wabaChat.conversations
    .filter((c) => c.isHistory)
    .reduce((sum, c) => sum + (c.unread || 0), 0);

export default wabaChatSlice.reducer;